import React, { useState, useEffect, useContext } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import Publish from "./Publish";
import AuthWizardProvider from "../../common/wizard/AuthWizardProvider";
import APICall from "../../../services/apiCall";
import AppContext, { AuthWizardContext } from "../../../context/Context";
import { PublishAppContext } from "../../../context/Context";
import { Redirect } from "react-router-dom";
import { Image } from "react-bootstrap";
import publishAppIconWhy from "../../../assets/img/icons/publishAppIconWhy.png";
import publishAppOnboardingReq from "../../../assets/img/icons/publishAppOnboardingReq.json";
import LottieAnimation from "../../common/Animation/LottieAnimation";
import registrationinstallation from "../../../assets/img/icons/registration&installation.json";
// import SikkaAppLogo from "";
import { sikkaimagelogo } from "./sikkaimagelogo";
const PublishApplication = ({ skipBillingCheck = false }) => {
  const [redirectToPayment, setRedirectToPayment] = useState(false);
  const [partnerDetails, setPartnerDetails] = useState({});
  const [applicationList, setApplicationList] = useState([]);
  const [marketplaceBackgroundImage, setMarketplaceBackgroundImage] = useState(
    []
  );
  const [promotionalImage1, setPromotionalImage1] = useState([]);
  const [promotionalImage2, setPromotionalImage2] = useState([]);
  const [promotionalImage3, setPromotionalImage3] = useState([]);
  const [confirmationImage, setConfirmationImage] = useState("Default");
  const [description, setDescription] = useState("");
  const [thankYouNote, setThankYouNote] = useState("");
  const [contentConfirmationEmail, setContentConfirmationEmail] = useState("");
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [
    automaticRegistrationHandshakeIdx,
    setAutomaticRegistrationHandshakeIdx,
  ] = useState(0);
  const [marketPlaceListingValues, setMarketPlaceListingValues] = useState({
    redirectToConfirmationPage: "Yes",
  });
  const [selectedApplication, setSelectedApplication] = useState();
  const [rowSelection, setRowSelection] = useState({});

  const { loginUserDetails } = useContext(AppContext);
  const [partnerlogoImage, setPartnerlogoImage] = useState("");
  const [partnerTagline, setPartnerTagline] = useState("");
  const [
    selectedFreshdeskOptionValue,
    setSelectedFreshdeskOptionValue,
  ] = useState({
    selectedFreshdeskOption: {
      label: "Yes",
      value: "Yes",
    },
    selectedFreshdeskOptionForNotification: {
      label: "Yes",
      value: "Yes",
    },
  });

  const [needSikkaAppsLicense, setNeedSikkaAppsLicense] = useState({
    label: "Yes",
    value: "Yes",
  });
   const [apiLicenseValue, setAPILicenseValue] = useState(selectedApplication?.plan_name);
  const [getApplicationInfomation, setGetApplicationInfomation] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const { step } = useContext(AuthWizardContext);
  const [onlyOneTimeFill, setOnlyOneTimeFill] = useState(true);

  const publishAppContext = {
    partnerDetails,
    marketplaceBackgroundImage,
    promotionalImage1,
    promotionalImage2,
    promotionalImage3,
    confirmationImage,
    description,
    thankYouNote,
    contentConfirmationEmail,
    categoryIndex,
    automaticRegistrationHandshakeIdx,
    applicationList,
    marketPlaceListingValues,
    selectedApplication,
    rowSelection,
    partnerlogoImage,
    apiLicenseValue,
    selectedFreshdeskOptionValue,
    needSikkaAppsLicense,
    partnerTagline,
    getApplicationInfomation,
    isEditMode, setIsEditMode,onlyOneTimeFill, setOnlyOneTimeFill,
    setSelectedFreshdeskOptionValue,
    setNeedSikkaAppsLicense,
    setAPILicenseValue,
    setPartnerDetails,
    setApplicationList,
    setMarketplaceBackgroundImage,
    setPromotionalImage1,
    setPromotionalImage2,
    setPromotionalImage3,
    setConfirmationImage,
    setDescription,
    setContentConfirmationEmail,
    setThankYouNote,
    setCategoryIndex,
    setAutomaticRegistrationHandshakeIdx,
    setMarketPlaceListingValues,
    setSelectedApplication,
    setRowSelection,
    setPartnerlogoImage,
    setPartnerTagline,
    setGetApplicationInfomation,
  };

  const hostName = (url) => {
    if (url.includes("localhost")) {
      return "Q";
    } else if (url.includes("qa")) {
      return "Q";
    } else {
      return "P";
    }
  };

  useEffect(() => {
    if (skipBillingCheck) {
      return;
    }
    let params = {
      devid: loginUserDetails.parent_dev_id,
      host: hostName(window.location.href),
    };

    APICall.servertrip(
      "GET",
      "check_for_stored_card",
      loginUserDetails,
      params
    ).then(
      (res) => {
        setRedirectToPayment(res.data.items);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    // setPartnerlogoImage(SikkaAppLogo);
  }, []);

    useEffect(() => {
    if (needSikkaAppsLicense?.value == "No") {
      setAPILicenseValue("");
    } else if (needSikkaAppsLicense?.value == "Yes") {
      setAPILicenseValue(selectedApplication?.plan_name);
    }
  }, [needSikkaAppsLicense?.value, selectedApplication]);

  useEffect(() => {
    if (selectedFreshdeskOptionValue.selectedFreshdeskOption?.value == "No") {
      setSelectedFreshdeskOptionValue({
        ...selectedFreshdeskOptionValue,
        selectedFreshdeskOptionForNotification: { value: "No", label: "No" },
      });
    }
  }, [selectedFreshdeskOptionValue.selectedFreshdeskOption?.value]);

  useEffect(() => {
    setPartnerlogoImage(sikkaimagelogo);
  }, [selectedApplication]);
  return (
    <div>
      {redirectToPayment ? (
        <Redirect
          to={{
            pathname: "billing",
            state: { defaultKey: "payment", redirectFromPublishApp: true },
          }}
        />
      ) : (
        <PublishAppContext.Provider value={publishAppContext}>
          <Col className="col-12 p-0">
            <Card>
              <SikkaCardHeader title={"Publish Application"} />
              <CardBody>
                <Row className="ml-1 ml-md-4 ml-lg-7 ml-xl-7">
                  <Col className="col-1">
                    <Image src={publishAppIconWhy} width={45} height={45} />
                  </Col>
                  <Col>
                    <div className="fs-0" style={{ fontWeight: 700 }}>
                      Why I need to publish my application?
                    </div>
                    <p className="lead fs--1">
                      The purpose of publish application is to assist you in
                      creating a service/product landing page on{" "}
                      <a
                        href="https://www.sikkasoft.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Sikka Marketplace
                      </a>{" "}
                      so your customer or visitor of sikka marketplace can
                      signup for your application.
                    </p>
                  </Col>
                </Row>
                <Row className="mt-3 mb-4">
                  <Col className="d-flex justify-content-center align-items-center">
                    <LottieAnimation
                      lotti={publishAppOnboardingReq}
                      height={70}
                      width={70}
                    />
                    <a
                      className="fs--1"
                      href="https://api.sikkasoft.com/portal/pdf/Sikka%20Marketplace-partner_onboarding_requirement.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sikka Marketplace: Partner-Onboarding Requirements
                    </a>
                  </Col>
                  <Col className="d-flex justify-content-center align-items-center">
                    <LottieAnimation
                      lotti={registrationinstallation}
                      height={65}
                      width={70}
                    />
                    <a
                      className="fs--1"
                      href="https://api.sikkasoft.com/portal/pdf/Registration%20and%20installation%20process%20for%20your%20application%20users.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Registration and installation process for your application
                    </a>
                  </Col>
                </Row>
                <AuthWizardProvider>
                  <Publish validation={true} />
                </AuthWizardProvider>
              </CardBody>
            </Card>
          </Col>
        </PublishAppContext.Provider>
      )}
    </div>
  );
};

export default PublishApplication;
